import Tabs from "devextreme-react/tabs";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useTitle } from "../../../../contexts/title";
import { AR } from "../../../../types/enums";
import { EstimateContext } from "../context/EstimateContext";
import { EstimateProgressStepInfo } from "../types/EstimateProgressStepInfo";

export default function EstimateProgress() {

	const { order } = useContext(EstimateContext);

	const location = useLocation();
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const resolvedIcon = 'dx-icon dx-icon-Inscyth-Checked-Box';
	const unresolvedIcon = '';

	var steps: EstimateProgressStepInfo[] =
		[
			{
				text: 'Info',
				navigateTo: '/cfi/estimate/' + order.details.quoteID,
				disabled: false,
				icon: 'dx-icon dx-icon-info'
			},
			{
				text: 'Contact',
				navigateTo: '/cfi/estimate/' + order.details.quoteID + '/10',
				disabled: !order.details.resolvedARs.includes(AR.LeadContactCustomer) &&
					!order.details.activeARs.includes(AR.LeadContactCustomer),
				icon: order.details.resolvedARs.includes(AR.LeadContactCustomer) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Schedule',
				navigateTo: '/cfi/estimate/' + order.details.quoteID + '/20',
				disabled: !order.details.resolvedARs.includes(AR.LeadScheduleAppointment) &&
					!order.details.activeARs.includes(AR.LeadScheduleAppointment),
				icon: order.details.resolvedARs.includes(AR.LeadScheduleAppointment) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Estimate',
				navigateTo: '/cfi/estimate/' + order.details.quoteID + '/30',
				disabled: !order.details.resolvedARs.includes(AR.LeadSubmitEstimate) &&
					!order.details.activeARs.includes(AR.LeadSubmitEstimate),
				icon: order.details.resolvedARs.includes(AR.LeadSubmitEstimate) ? resolvedIcon : unresolvedIcon
			}
		]

	let selectedStep: EstimateProgressStepInfo | undefined;

	steps.forEach(step => {
		if (location.pathname.includes(step.navigateTo) && (!selectedStep || selectedStep.navigateTo < step.navigateTo)) {
			selectedStep = step;
		}
	});

	const pageTitle = useTitle();
	useEffect(() => {
		if (selectedStep) {
			pageTitle.setTitle(selectedStep?.text)
		}
	}, [pageTitle, selectedStep]);

	return (
		<Tabs
			className="order-progress"
			dataSource={steps}
			selectedItem={selectedStep}
			onItemClick={(e) => navigate(e.itemData?.navigateTo! + (!!returnUrl ? '?returnUrl=' + returnUrl : ''))}
		>

		</Tabs>
	);
}
